const VUE_APP_BASE_URL = `https://backoffice.stark-solutions.online`;
const API_BASE_URL = '/api/';
const DEFAULT_COUNTRY_CODE = 'DEFAULT';
const DEFAULT_RECAPTCHA_KEY = '6LdPahoaAAAAAH758PyC8QfyravcIXUqRfLKpNeR';
export {
    API_BASE_URL,
    DEFAULT_COUNTRY_CODE,
    DEFAULT_RECAPTCHA_KEY
};
export default VUE_APP_BASE_URL;
